import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "CrmModule"
const debug = false

export class CrmModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.CRM, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "CRM"
        this.description             = "The GoodDay CRM module serves as a comprehensive solution for customer relationship management, offering robust tools for managing CRM contacts and accounts across various functions such as sales, support, and more. This feature allows users to seamlessly connect their work or projects with CRM data, facilitating better coordination and collaboration across teams. By centralizing CRM contacts and accounts within GoodDay, users can efficiently track and manage customer interactions, leads, opportunities, and support requests, ultimately fostering stronger customer relationships and enhancing overall customer satisfaction."
        this.svgIcon                 = "isvg-crm-settings"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "CRM"
        this.settingsUrl             = "settings/crm-settings"
        this.parentSection              = SettingsParentSection.CRM

        this.feature                = Feature.CRM
        this.validateFeature()


    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}